(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zein-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function cerrarTodosLosDrawers() {
      document.querySelectorAll('.zein-encabezado--drawer-abierto').forEach(function (header) {
        cerrarDrawer(header);
      });
    }

    function abrirDrawer(header) {
      var drawer = header.querySelector('.zein-encabezado__drawer');
      var boton = header.querySelector('.zein-encabezado__boton-mobile');

      cerrarTodosLosDrawers();

      header.classList.add('zein-encabezado--drawer-abierto');
      document.body.classList.add('zein-encabezado-bloqueo-scroll');

      if (drawer) {
        drawer.setAttribute('aria-hidden', 'false');
      }

      if (boton) {
        boton.setAttribute('aria-expanded', 'true');
      }
    }

    function cerrarDrawer(header) {
      var drawer = header.querySelector('.zein-encabezado__drawer');
      var boton = header.querySelector('.zein-encabezado__boton-mobile');

      header.classList.remove('zein-encabezado--drawer-abierto');

      if (!document.querySelector('.zein-encabezado--drawer-abierto')) {
        document.body.classList.remove('zein-encabezado-bloqueo-scroll');
      }

      if (drawer) {
        drawer.setAttribute('aria-hidden', 'true');
      }

      if (boton) {
        boton.setAttribute('aria-expanded', 'false');
      }
    }

    document.addEventListener('click', function (event) {
      var botonAbrir = event.target.closest('.zein-encabezado__boton-mobile');
      var botonCerrar = event.target.closest('.zein-encabezado__drawer-cerrar');
      var overlay = event.target.closest('.zein-encabezado__overlay');
      var botonSubmenu = event.target.closest('.zein-encabezado__drawer-toggle');

      if (botonAbrir) {
        var headerAbrir = botonAbrir.closest('.zein-encabezado');

        if (headerAbrir) {
          abrirDrawer(headerAbrir);
        }
      }

      if (botonCerrar) {
        var headerCerrar = botonCerrar.closest('.zein-encabezado');

        if (headerCerrar) {
          cerrarDrawer(headerCerrar);
        }
      }

      if (overlay) {
        var headerOverlay = overlay.closest('.zein-encabezado');

        if (headerOverlay) {
          cerrarDrawer(headerOverlay);
        }
      }

      if (botonSubmenu) {
        var fila = botonSubmenu.closest('.zein-encabezado__drawer-fila');
        var sublista = fila ? fila.nextElementSibling : null;
        var abierto = botonSubmenu.getAttribute('aria-expanded') === 'true';

        botonSubmenu.setAttribute('aria-expanded', abierto ? 'false' : 'true');

        if (sublista) {
          sublista.hidden = abierto;
        }
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        cerrarTodosLosDrawers();
      }
    });

    document.addEventListener('shopify:section:unload', function () {
      document.body.classList.remove('zein-encabezado-bloqueo-scroll');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
